/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Cargos_As_Of_BannerInputs */

const en_cargos_as_of_banner = /** @type {(inputs: Cargos_As_Of_BannerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Viewing inventory as of end of ${i?.date}. Bag quantities are reconstructed from the audit ledger; status, reservations and other fields reflect current values. Editing is disabled.`)
};

const es_cargos_as_of_banner = /** @type {(inputs: Cargos_As_Of_BannerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Viendo el inventario al final del ${i?.date}. Las cantidades de bolsas se reconstruyen a partir del registro de auditoría; el estado, las reservas y otros campos reflejan los valores actuales. La edición está deshabilitada.`)
};

/**
* | output |
* | --- |
* | "Viewing inventory as of end of {date}. Bag quantities are reconstructed from the audit ledger; status, reservations and other fields reflect current values. ..." |
*
* @param {Cargos_As_Of_BannerInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargos_as_of_banner = /** @type {((inputs: Cargos_As_Of_BannerInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargos_As_Of_BannerInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargos_as_of_banner(inputs)
	return es_cargos_as_of_banner(inputs)
});